import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section className="mx-auto max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
      <div className="relative overflow-hidden rounded-lg">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20amber%20abstract%20gradient%20texture%20with%20soft%20light%20streaks%2C%20minimal%20editorial%20background%2C%20elegant%20and%20calm%2C%20high%20detail&width=1600&height=700&seq=guanji-subscribe-cta-01&orientation=landscape"
            alt="订阅合集更新背景图"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-primary-950/70" />
        </div>
        <div className="relative grid grid-cols-1 gap-8 px-6 py-12 md:grid-cols-2 md:items-center md:px-12 md:py-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-medium text-primary-200">
              <i className="ri-notification-3-line text-sm" />
              每周更新提醒
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              新的独家吃瓜合集，第一时间送到
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              订阅后每周收到一封整理好的目录：新增专题、热门盘点与值得回看的合集，随时取消。
            </p>
          </div>
          <div className="md:pl-4">
            <SubscribeForm tone="dark" />
            <p className="mt-4 text-xs text-background-300">
              我们只用邮箱发送合集更新，不会用于其他用途。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}